// extracted by mini-css-extract-plugin
module.exports = {"cont-photos":"cont-photos","contPhotos":"cont-photos"};